<!-- 季度 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add">新增</el-button>
        </template>
      </dynamic-search>
      <drag-dialog
        append-to-body
        :show.sync="dialogVisible"
        title="季度"
        :enableDrag="true"
        width="500px"
        @close="cancel"
      >
        <dynamic-form
          :formConfig="formConfig"
          labelWidth="120px"
          v-model="form"
          @submit="submit"
          @cancelForm="cancel"
          ref="pageForm"
        ></dynamic-form>
      </drag-dialog>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-edit" style="color:#4084B7" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button :loading="delLoading" type="primary" size="mini" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DragDialog from "@/components/DragDialog";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import "@/components/dynamic-form";
import { addQuarter,delQuarter,editQuarter} from "@/api/quarters";

export default {
  name: "Quarter",
  components: {
    DynamicSearch,
    DragDialog
  },
  mixins: [DataTableMixin],
  data() {
    return {
      delLoading: false,
      form: {},
      dialogVisible: false,
      // 表单配置
      formConfig: {
        formItemList: [
          {
            type: "input",
            maxlength: "50",
            showWordLimit: true,
            key: "code",
            label: "季度代码",
            value: "",
             rules: [
              { required: true, message: "季度代码不能为空", trigger: "blur" },
              {
                pattern: "^[^\u4e00-\u9fa5]{0,}$",
                message: "季度代码不能含有中文",
                trigger: "blur"
              },
            ]
          },
          {
            type: "select",
            maxlength: "500",
            showWordLimit: true,
            key: "name",
            label: "名称",
            value: "",
            options: [
              {label: '第一季度', value: '第一季度'},
              {label: '第二季度', value: '第二季度'},
              {label: '第三季度', value: '第三季度'},
              {label: '第四季度', value: '第四季度'},
            ],
            placeholder: "请输入名称",
            rules: [
              { required: true, message: "名称不能为空", trigger: "blur" }
            ]
          },
          {
           type: "date",
            maxlength: "100",
            showWordLimit: true,
            key: "annual",
            label: "年度",
            subtype: "year",
            value: "",
              valueFormat: "yyyy",
            rules: [
              {required: true, message: "年度不能为空", trigger: "blur"}
            ]
          },
          {
            type: "date",
            maxlength: "200",
            key: "beginTime",
            label: "开始时间",
            value: "",
             rules: [
              { required: true, message: "开始时间不能为空", trigger: "blur" }
            ]
          },
          {
            type: "date",
            maxlength: "200",
            key: "endTime",
            label: "结束时间",
            value: "",
             rules: [
              { required: true, message: "结束时间不能为空", trigger: "blur" }
            ]
          },
          {
            type: "number",
            maxlength: "100",
            showWordLimit: true,
            key: "percent",
            label: "季度指标占比",
            value: "",
            rules: [
              {required: true, message: "季度指标占比不能为空", trigger: "blur"}
            ]
          },
          {
            type: "textarea",
            maxlength: "200",
            showWordLimit: true,
            validateEvent: true,
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注"
          }
        ]
      },
      tableHead: [
        {
          prop: "code",
          label: "季度代码",
        },
         {
          prop: "annual",
          label: "年度",
        },
        {
          prop: "name",
          label: "名称",
          query: {
            type: "input"
          }
        },
          {
          prop: "beginTime",
          label: "开始时间",
        },
          {
          prop: "endTime",
          label: "结束时间",
        },
         {
          prop: "percent",
          label: "季度指标占比",
        },
        {
          prop: "remark",
          label: "备注",
        }
      ],
      tableData: [],
      arr: []
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      // console.log(1);
      this.dataTableInit();
    });
  },
  methods: {
    cancel() {
      this.dialogVisible = false;
    },
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/quarter`;
      const params = { page: this.page, size: this.offset};
      this._params = Object.assign(params, this._query);
      return true;
    },
    // 删除
    del(row) {
      // console.log(row);
      this.delLoading = true;
      delQuarter(row.id)
        .then(() => {
          this.$notify({
            title: '删除成功！',
            type: 'success',
            duration: 2500
          })
          this.dataTableInit();
          this.delLoading = false;
        })
        .catch(() => {
          this.delLoading = false;
        });
    },
    // 新增
    add() {
      this.form = {beginTime: '',endTime: ''};
      this.dialogVisible = true;
    },
    // 修改
    edit(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    // 提交 （添加/修改）
    submit() {
        this.form.beginTime = new Date(this.form.beginTime).getTime()
        this.form.endTime = new Date(this.form.endTime).getTime()
      if (this.form.id) {
        editQuarter(this.form).then(res => {
           this.$notify({
            title: '修改成功！',
            type: 'success',
            duration: 2500
          })
          this.dataTableInit();
          this.cancel();
        });
      } else {
        addQuarter(this.form).then(res => {
          this.$notify({
            title: '添加成功！',
            type: 'success',
            duration: 2500
          })
          this.dataTableInit();
          this.cancel();
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
</style>
